<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">

    <div class="vx-card p-6">
      <div class="mt-5">
        <vs-tabs alignment="fixed">
          <vs-tab label="Maximum Idling">
            <MaximumIdling></MaximumIdling>
          </vs-tab>
          <vs-tab label="Maximum Parking">
            <MaximumParking></MaximumParking>
          </vs-tab>
          <vs-tab label="Service">
            <Service></Service>
          </vs-tab>
          <vs-tab label="Service Assignment">
            <ServiceAssignment></ServiceAssignment>
          </vs-tab>
        </vs-tabs>
      </div>

    </div>
  </div>

</template>

<script>
import vSelect from 'vue-select'
import MaximumIdling from './components/notifications/MaximumIdling.vue'
import MaximumParking from './components/notifications/MaximumParking.vue'
import Service from './components/notifications/Service.vue'
import ServiceAssignment from './components/notifications/ServiceAssignment.vue'

export default {
  components: {
    vSelect,
    MaximumIdling,
    MaximumParking,
    Service,
    ServiceAssignment,
  },

  data () {
    return {
      token: '',
      actor: ''
    }
  },

  created () {
    this.token = localStorage.getItem('userInfo') !== null ? JSON.parse(localStorage.getItem('userInfo')).token : ''

    this.$http.get(`${this.$api.endpoint}/user/profile`, {
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    }).then(res => {
      this.actor = res.data.message.data

    }).catch(error => {
      this.$gf.httpErrorHandler(error)
    })
  }
}

</script>
